import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';

@Component({
	standalone: true,
	imports: [NgClass],
	selector: 'wd-confirm-modal',
	template: `
		<div class="modal-header">
			<h5 class="modal-title">{{ title }}</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<p [innerHTML]="message"></p>
		</div>
		<div class="modal-footer">
			@if (cancelText) {
				<button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{ cancelText }}</button>
			}
			@if (extraText) {
				<button type="button" class="btn" [ngClass]="extraClass" (click)="activeModal.close('extra')">{{ extraText }}</button>
			}
			<button type="button" class="btn" [ngClass]="confirmClass" (click)="activeModal.close(true)">{{ confirmText }}</button>
		</div>
	`,
	styles: [`
		.modal-body p {
			margin-bottom: 0;
			white-space: pre-line;
		}
	`],
})
export class ConfirmModalComponent {
	@Input() title = 'Bestätigung';
	@Input() message = '';
	@Input() confirmText = 'OK';
	@Input() cancelText = 'Abbrechen';
	@Input() confirmClass = 'btn-primary';
	@Input() extraText = '';
	@Input() extraClass = 'btn-success';

	constructor(public activeModal: NgbActiveModal) {}
}
